import { referralFixture } from './fixture';
import type {
  ReferralActivityItem,
  ReferralEarningsEntry,
  ReferralHistoryItem,
  ReferralHistoryStats,
  ReferralListItem,
  ReferralSummary,
} from '@/types/referral';

const cloneReferralMockState = () => ({
  summary: structuredClone(referralFixture.summary) as ReferralSummary,
  referrals: structuredClone(
    referralFixture.referrals
  ) satisfies ReferralListItem[],
  activity: structuredClone(
    referralFixture.activity
  ) satisfies ReferralActivityItem[],
  historyStats: structuredClone(
    referralFixture.historyStats
  ) satisfies ReferralHistoryStats,
  history: structuredClone(referralFixture.history) satisfies Record<
    'active' | 'completed' | 'expired',
    ReferralHistoryItem[]
  >,
  earnings: structuredClone(
    referralFixture.earnings
  ) as ReferralEarningsEntry[],
});

export const referralMockState = cloneReferralMockState();

export const resetReferralMockState = () => {
  const nextState = cloneReferralMockState();
  referralMockState.summary = nextState.summary;
  referralMockState.referrals = nextState.referrals;
  referralMockState.activity = nextState.activity;
  referralMockState.historyStats = nextState.historyStats;
  referralMockState.history = nextState.history;
  referralMockState.earnings = nextState.earnings;
};

const mockDelay = (ms = 250) =>
  new Promise<void>((resolve) => {
    window.setTimeout(resolve, ms);
  });

export const waitForReferralMock = mockDelay;
